var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJobsNavIcon = function SvgJobsNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M7.906 2.063h6.188c.189 0 .344.154.344.343v1.719H7.562V2.406c0-.189.155-.344.344-.344M5.5 2.406v1.719H2.75A2.753 2.753 0 0 0 0 6.875V11h22V6.875a2.753 2.753 0 0 0-2.75-2.75H16.5V2.406A2.41 2.41 0 0 0 14.094 0H7.906A2.41 2.41 0 0 0 5.5 2.406M22 12.375h-8.25v1.375c0 .76-.614 1.375-1.375 1.375h-2.75c-.76 0-1.375-.614-1.375-1.375v-1.375H0v5.5a2.753 2.753 0 0 0 2.75 2.75h16.5a2.753 2.753 0 0 0 2.75-2.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M7.906 2.063h6.188c.189 0 .344.154.344.343v1.719H7.562V2.406c0-.189.155-.344.344-.344M5.5 2.406v1.719H2.75A2.753 2.753 0 0 0 0 6.875V11h22V6.875a2.753 2.753 0 0 0-2.75-2.75H16.5V2.406A2.41 2.41 0 0 0 14.094 0H7.906A2.41 2.41 0 0 0 5.5 2.406"
  })));
};
export default SvgJobsNavIcon;